import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Headphones, Play, Pause } from "lucide-react";

export default function AmbientPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="fixed bottom-6 left-6 z-50 flex items-end gap-2"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <motion.button
        onClick={() => setIsPlaying(!isPlaying)}
        className={`h-10 w-10 rounded-full flex items-center justify-center backdrop-blur-md shadow-lg border transition-all duration-500 ${
          isPlaying 
            ? "bg-[var(--nily-teal)] text-[var(--bg-main)] border-[var(--nily-teal)]" 
            : "bg-[var(--glass-bg)] text-[var(--text-muted)] border-[var(--glass-border)] hover:text-[var(--text-main)]"
        }`}
      >
        {isPlaying ? (
          <div className="flex gap-0.5 items-center h-3">
            {[1,2,3,4].map(i => (
              <motion.div 
                key={i} 
                className="w-0.5 bg-[var(--bg-main)] rounded-full"
                animate={{ height: [4, 12, 4] }}
                transition={{ duration: 0.5, repeat: Infinity, delay: i * 0.1 }}
              />
            ))}
          </div>
        ) : (
          <Headphones size={16} />
        )}
      </motion.button>

      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, x: -10, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -10, scale: 0.95 }}
            className="h-10 px-4 rounded-full bg-[var(--glass-bg)] border border-[var(--glass-border)] backdrop-blur-xl shadow-xl flex items-center gap-4"
          >
            <span className="text-[10px] font-mono text-[var(--nily-teal)] uppercase tracking-widest whitespace-nowrap">
              {isPlaying ? "Focus Stream Active" : "Ambient Mode"}
            </span>
            
            <div className="h-4 w-[1px] bg-[var(--glass-border)]" />
            
            <button onClick={() => setIsPlaying(!isPlaying)}>
               {isPlaying ? <Pause size={12} className="text-[var(--text-main)]" /> : <Play size={12} className="text-[var(--text-main)]" />}
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
